var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleWithPlusWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5322 0.25C8.44857 0.25 0.291016 8.40756 0.291016 18.4912C0.291016 28.5749 8.44857 36.7324 18.5322 36.7324C28.6159 36.7324 36.7734 28.5749 36.7734 18.4912C36.7734 8.40756 28.6159 0.25 18.5322 0.25ZM27.5584 19.5487H19.3253V27.7818C19.3253 28.3483 18.8721 28.8015 18.3056 28.8015C17.7391 28.8015 17.2859 28.3483 17.2859 27.7818V19.5487H9.0906C8.52411 19.5487 8.07091 19.0955 8.07091 18.529C8.07091 17.9625 8.52411 17.5093 9.0906 17.5093H17.3237V9.27619C17.3237 8.70969 17.7769 8.25649 18.3434 8.25649C18.9099 8.25649 19.3631 8.70969 19.3631 9.27619V17.5093H27.5962C28.1627 17.5093 28.6159 17.9625 28.6159 18.529C28.5781 19.0955 28.1249 19.5487 27.5584 19.5487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithPlusWhite);
export default __webpack_public_path__ + "static/media/CircleWithPlusWhite.2d5513a42545f49a87bc8f0f7a611ff5.svg";
export { ForwardRef as ReactComponent };